<template>
    <eqt-table
      :icon="icon"
      :color="color"
      :header-color="headerColor"
      :hide-search="hideSearch"
      :hide-pagination="hidePagination"
      :hide-show-btn="hideShowBtn"
      :hide-edit-btn="hideEditBtn"
      @refresh="refresh"
      @delete="deleteItem"
      :total="total"
      :loading="loading"
      :title="computedTitle"
      :hide-actions="hideActions"
      :subtitle="computedSubtitle"
      :items="items"
      :headers="computedHeaders"
      :itemKey="'index'">
      <template slot="add">
        <slot name="add"></slot>
      </template>
      <template slot="items" slot-scope="{ item }">
        <td>{{ item.id }}</td>
        <td>{{ item.name}}</td>
        <slot name="items" :item="item"></slot>
      </template>
    </eqt-table>
</template>

<script>
    import i18n from '@/i18n'
    import EqtTable from '../../components/core/Table'
    export default {
        name: "products-table",
        components: {EqtTable},
        props: {
          items: {
            type: Array,
            required: true
          },
          total: {
            type: Number,
            default: 0,
          },
          loading: {
            type: Boolean,
            default: false
          },
          hideActions: {
            type: Boolean,
            default: false
          },
          icon: {
            type: String,
            default: ''
          },
          color: {
            type: String,
            default: 'tertiary'
          },
          headerColor: {
            type: String,
            default: 'text-primary text--darken-3'
          },
          title: {
            type: String,
            default: null,
          },
          subtitle: {
            type: String,
            default: null,
          },
          hideSubtitle: {
            type: Boolean,
            default: false
          },
          hidePagination: {
            type: Boolean,
            default: false
          },
          hideSearch: {
            type: Boolean,
            default: false
          },
          hideShowBtn: {
            type: Boolean,
            default: false
          },
          hideEditBtn: {
            type: Boolean,
            default: false
          },
          sortable: {
            type: Boolean,
            default: true
          },
          appendHeaders: {
            type: Array,
            default: () => []
          },
        },
        data: () => ({
          headers: [
            {
              sortable: true,
              text: '#',
              value: 'id'
            },
            {
              sortable: true,
              text: i18n.t('Pages.Products.model.name'),
              value: 'name'
            },
          ],
        }),
        computed:{
          computedHeaders(){
            return this.headers.concat(this.appendHeaders);
          },
          computedTitle(){
            return this.title ? this.title : this.$t('Pages.Products.title');
          },
          computedSubtitle(){
            if(this.hideSubtitle){
              return null;
            }
            return this.subtitle ? this.subtitle : this.$t('Common.table_subtitle');
          }
        },
        methods: {
            refresh(data){
                this.$emit('refresh', data);
            },
            deleteItem(item){
                this.$emit('delete', item);
            }
        },
        watch: {

        }
    }
</script>

<style scoped>

</style>
